import type { ComponentType } from 'react';
import { SubIdExperienceVariant } from 'config/enums';
import morrisonImage from 'assets/images/morrison-brothers.png';

export type WelcomeVariantConfig = {
  headingKey: string;
  descriptionKey: string;
  image?: ComponentType | string;
};

export const WELCOME_VARIANTS: Partial<Record<SubIdExperienceVariant, WelcomeVariantConfig>> = {
  [SubIdExperienceVariant.Morrison]: {
    headingKey: 'welcome.heading.morrison',
    descriptionKey: 'welcome.description.morrison',
    image: morrisonImage,
  },
};
